const displayName = "Nätverk"
const appName = "network"

export { displayName, appName }
